import { DateTime } from 'luxon';
import ExcelJS from 'exceljs';
import saveAs from 'file-saver';
import DateFormat from '../dateFormat/DateFormat';

export default class Excel {
    
    static FORMATOS = {
        numeroInteiro: { tipo: 'numero', formatacao: '#' },
        numeroDecimal1: { tipo: 'numero', formatacao: '#,##0.0' },
        numeroDecimal2: { tipo: 'numero', formatacao: '#,##0.00' },
        numeroDecimal3: { tipo: 'numero', formatacao: '#,##0.000' },
        numeroDecimal4: { tipo: 'numero', formatacao: '#,##0.0000' },

        moeda: { tipo: 'moeda', formatacao: '"R$" #,##0.00' },
        moeda1: { tipo: 'moeda', formatacao: '"R$" #,##0.0' },
        moeda3: { tipo: 'moeda', formatacao: '"R$" #,##0.000' },
        moeda4: { tipo: 'moeda', formatacao: '"R$" #,##0.0000' },

        numeroInteiroPercentual: { tipo: 'percentual', formatacao: '0%' },
        numeroPercentual1: { tipo: 'percentual', formatacao: '0.0%' },
        numeroPercentual2: { tipo: 'percentual', formatacao: '0.00%' },
        numeroPercentual3: { tipo: 'percentual', formatacao: '0.000%' },
        numeroPercentual4: { tipo: 'percentual', formatacao: '0.0000%' },

        data: { tipo: 'data', formatacao: 'dd/mm/yyyy' },
        dataHora: { tipo: 'dataHora', formatacao: 'dd/mm/yyyy hh:mm:ss' },
        padrao: { tipo: 'padrao', formatacao: '@' }
    };

    /**
     * @param {string} filename
     * @param {Array} colunas [{ atributo, nome, largura, formato }]
     * @param {Array} dados   [{ atributo: valor }]
     */
    static async exportar(filename, colunas, dados) {

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet(filename);

        // Configuração das colunas
        worksheet.columns = colunas.map(col => ({
            key: col.atributo,
            header: col.nome,
            width: col.largura,
            style: { numFmt: col.formato ? col.formato.formatacao : this.FORMATOS.padrao.formatacao }
        }));

        // Converter dados conforme tipo
        const linhasFormatadas = dados.map(item => {

            const novaLinha = {};

            colunas.forEach(col => {

                let valor = item[col.atributo];

                if (valor === null || valor === undefined || valor === '') {
                    novaLinha[col.atributo] = null;
                    return;
                }

                const tipo = col.formato ? col.formato.tipo : this.FORMATOS.padrao.tipo;            
                
                switch (tipo) {

                    case 'padrao':
                        novaLinha[col.atributo] = valor;
                        break;

                    case 'numero':
                        novaLinha[col.atributo] = Number(valor);
                        break;

                    case 'moeda':
                        novaLinha[col.atributo] = Number(valor);
                        break;

                    case 'percentual':
                        novaLinha[col.atributo] = Number(valor);
                        break;

                    case 'data':
                        novaLinha[col.atributo] = DateFormat.formatarDataSqlParaExcel(valor);                        
                        break;        

                    case 'dataHora':
                        novaLinha[col.atributo] = DateFormat.formatarDataHoraSqlParaExcel(valor);                        
                        break;

                    default:
                        novaLinha[col.atributo] = valor;
                }
            });

            return novaLinha;
        });
        
        worksheet.addRows(linhasFormatadas);

        // Alinhamento automático por tipo
        colunas.forEach((col, index) => {

            const tipo = col.formato ? col.formato.tipo : 'padrao';

            if (['moeda', 'percentual'].includes(tipo)) {
                worksheet.getColumn(index + 1).alignment = { horizontal: 'right' };
            }

            if (['numero', 'data', 'dataHora', 'padrao'].includes(tipo)) {
                worksheet.getColumn(index + 1).alignment = { horizontal: 'center' };
            }
        });

        // Gerar arquivo
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob(
            [buffer],
            { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
        );

        saveAs(blob, `${filename}.xlsx`);
    }
}
